import { useState, useRef } from 'react';
import { HideLoder, LogInSchoolID, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { useSelector } from 'react-redux';
import { ApiCmnHeadersPostCall, } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import useConfig from '../../../Hooks/useConfig';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';

export default function Importtickets() {
    const { ticketsFileType, csvFilesPrefix } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const RepairTicketRef = useRef();
    const [fileName, setFileName] = useState({
        tickets: '',
        error: ''
    });
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [csvError, setCsvError] = useState("");
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });

    async function ImportRepairTicketCSV(e) {
        setCsvError('');
        setLoading(true)
        e.preventDefault();
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });

        const fileInput = RepairTicketRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false);
            setFileName({ ...fileName, error: "First, import the CSV file.", tickets: '' });
            fileInput.value = ""
            return;
        }
        const filename = files.name;

        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setLoading(false);
            setFileName({ ...fileName, tickets: "", error: validationMsg });
            fileInput.value = ""
            return;
        }
        setFileName({ ...fileName, tickets: filename, error: "" });

        const formdata = new FormData();
        formdata.append("file", files);
        formdata.append("uuid", StateData?.csvUserID);
        formdata.append("schoolId", LogInSchoolID);
        formdata.append("flag", 1);
        formdata.append("cronFlag", 0);

        ApiCmnHeadersPostCall(`/tickets/import`, formdata, false, true)
            .then(result => {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'If there was any mismatched or invalid data, or any mismatched headers in your CSV, those entries would have been skipped.'} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        navigate('/manage-tickets')
                    }, 1500);
                } else {
                    setCsvError(responseRs);
                    setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                    fileInput.value = "";
                    setFileName({ ...fileName, error: '', tickets: '' });
                }
                fileInput.value = ""
                setFileName({ ...fileName, error: '', tickets: '' });
            })
            .catch(error => {
                fileInput.value = ""
                setFileName({ ...fileName, error: '', tickets: '' });
                log.error('error', error)
            });
    }
    function ShowFileName(flag) {
        const fileInput = RepairTicketRef.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...fileName, error: validationMsg, tickets: "" });
            fileInput.value = ""
            return;
        }
        setFileName({ ...fileName, tickets: filename, error: "" });
    }
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Tickets</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure that Tickets are entered properly with data accuracy, please download our CSV template file and ensure your columns match the template before you import your tickets into the system.
                </p>
                <div className="row pt-3 px-3">
                    <label className="pb-4 ps-0 text-justify" style={{ fontSize: "13px" }}>
                        <a onClick={() => downloadSampleCSV(ticketsFileType, `${csvFilesPrefix ? `${csvFilesPrefix}_` : ''}Ticket.csv`)}
                            style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                            CLICK HERE
                        </a>{" "}
                        to download the template CSV file for tickets data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                    </label>
                    <div className="col-12">
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportRepairTicketCSV(e)}>
                                <input type="file" ref={RepairTicketRef} name="repairTicket_file" id="RepairTicketFile" accept='.csv' onChange={(e) => ShowFileName(4)} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="RepairTicketFile"> Import Tickets
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.tickets != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        {fileName.tickets && <label id="ImportInventoryRepairTicketText" style={{ fontWeight: "600", color: 'green' }}>{fileName.tickets}</label>}
                        {fileName.error?.trim() != "" && <label className='redText'>{fileName.error}</label>}
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </div>
    )
}
